import {initMapContainer} from "../../elements/div.map/index";

export const initObjects = () => {
	const objects = document.querySelector( 'section.objects' );

	if ( !objects )
	{
		return;
	}

	const arrangeCards = () => {
		const complexCards = objects.querySelectorAll( 'li.complex a, li.complex-parking a' );
		const otherCards = objects.querySelectorAll( 'ul.cards > li:not(.complex):not(.complex-parking)' );
		let maxComplexCardHeight = 0;
		let maxOtherCardHeight = 0;

		Array.from( complexCards ).forEach( ( card ) => {
			card.style.height = '';

			const cardHeight = getCardHeight( card );
			
			if ( maxComplexCardHeight < cardHeight )
			{
				maxComplexCardHeight = cardHeight;
			}
		} );

		Array.from( complexCards ).forEach( ( card ) => {
			const cardHeight = getCardHeight( card );
			
			if ( maxComplexCardHeight >= cardHeight )
			{
				card.style.height = maxComplexCardHeight + 'px';
			}
		} );

		Array.from( otherCards ).forEach( ( card ) => {
			card.style.height = ( complexCards[0].offsetHeight - window.getComputedStyle( card ).getPropertyValue( 'margin-bottom' ).replace( 'px', '' ) ) / 2 + 'px';
		} );
	};

	const getCardHeight = (card) => card.offsetHeight - window.getComputedStyle( card ).getPropertyValue( 'padding-top' ).replace( 'px', '' );

	arrangeCards();

	window.addEventListener( 'resize', () => {
		arrangeCards();
	} );

	const secondaryPrices = objects.querySelectorAll( 'div.secondary-prices' );

	if ( secondaryPrices.length )
	{
		Array.from( secondaryPrices ).forEach( ( it ) => {
			if ( it.querySelector( 'ul' ).classList.contains( 'items-1' ) )
			{
				return;
			}
			
			const priceItems = Array.from( it.querySelectorAll( 'li' ) );
			let currentItem = 0;
	
			priceItems.forEach( ( item, i ) => {
				if ( i === 0 )
				{
					return;
				}
	
				item.classList.add( 'hidden' );
			} );
	
			const changePrices = () => {
				priceItems[currentItem].classList.add( 'fading' );
				currentItem = currentItem < priceItems.length - 1 ? currentItem + 1 : 0;
				priceItems[currentItem].classList.remove( 'hidden' );
		
				const fadingTimeout = setTimeout( () => {
					const fadedItem = it.querySelector( 'li.fading' );
		
					fadedItem.classList.add( 'hidden' );
					fadedItem.classList.remove( 'fading' );
		
					clearTimeout( fadingTimeout );
				}, 500 );
			};
		
			setInterval( changePrices, 8000 );
		} );
	}
	
	const tabInput = document.querySelector( `main > input.tabs[id*="tabs_"][value="map"]` );
	const mapContainer = objects.querySelector( `div.map` );
	
	if ( tabInput && mapContainer)
	{
		/* При возвращении назад происходит ожидание загрузки данных */
		const setMapInitialization = () => {
			if ( tabInput.checked )
			{
				initMapContainer( mapContainer );
			}
			else
			{
				const initObjectsMap = () => {
					initMapContainer( mapContainer );
					
					tabInput.removeEventListener( `click`, initObjectsMap );
				};
				
				tabInput.addEventListener( `click`, initObjectsMap );
			}
		};
		
		setTimeout( setMapInitialization, 100 );
	}
};
